import {memo} from "react";
import {useRoutes} from "react-router-dom";
import { routes } from 'router/routes';

export const AppRoutes = memo(() => {
  return useRoutes(routes)
})
